// Module-level singleton. Persists within the browser tab; resets on page refresh.

function _genId() {
  return Math.random().toString(36).slice(2, 10).toUpperCase();
}

function _genMac() {
  return Array.from({ length: 6 }, () =>
    Math.floor(Math.random() * 256).toString(16).padStart(2, "0").toUpperCase()
  ).join(":");
}

function _fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

function _daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
}

function _hoursAgo(n) {
  const d = new Date();
  d.setHours(d.getHours() - n);
  return d.toISOString();
}

function _parseDevice() {
  const ua = navigator.userAgent || "";
  let browser = "Browser";
  let os = "Unknown OS";
  if (/chrome/i.test(ua) && !/edg/i.test(ua)) browser = "Chrome";
  else if (/safari/i.test(ua) && !/chrome/i.test(ua)) browser = "Safari";
  else if (/firefox/i.test(ua)) browser = "Firefox";
  else if (/edg/i.test(ua)) browser = "Edge";
  if (/windows nt/i.test(ua)) os = "Windows";
  else if (/macintosh|mac os x/i.test(ua)) os = "macOS";
  else if (/iphone/i.test(ua)) os = "iOS (iPhone)";
  else if (/ipad/i.test(ua)) os = "iOS (iPad)";
  else if (/android/i.test(ua)) os = "Android";
  else if (/linux/i.test(ua)) os = "Linux";
  return { browser, os, deviceName: `${browser} on ${os}` };
}

// Build a session object
function _session(loginAt, logoutAt, location, ip) {
  let duration = null;
  if (logoutAt) {
    const diffMs = new Date(logoutAt) - new Date(loginAt);
    const h = Math.floor(diffMs / 3600000);
    const m = Math.floor((diffMs % 3600000) / 60000);
    duration = h > 0 ? (m > 0 ? `${h}h ${m}m` : `${h}h`) : `${m}m`;
  }
  return { id: _genId(), loginAt, logoutAt, duration, location, ip };
}

function _endedSession(daysAgo, durationH, location, ip) {
  const login = new Date();
  login.setDate(login.getDate() - daysAgo);
  const logout = new Date(login.getTime() + durationH * 3600000);
  return _session(login.toISOString(), logout.toISOString(), location, ip);
}

const _store = {
  requests: [],
  devices: [],
};

let _seeded = false;

function _seed() {
  if (_seeded) return;
  _seeded = true;

  _store.devices.push(
    // Raj Kumar — 2 active devices
    {
      id: _genId(), analystId: "12", analystName: "Raj Kumar",
      deviceName: "Chrome on Windows", browser: "Chrome", os: "Windows",
      macAddress: _genMac(), location: "Mumbai, Maharashtra, India",
      approvedAt: _daysAgo(15), lastLogin: _hoursAgo(2), status: "active",
      sessions: [
        _session(_hoursAgo(2), null, "Mumbai, Maharashtra, India", "103.2.14.56"),
        _endedSession(1,  3.37, "Mumbai, Maharashtra, India", "103.2.14.56"),
        _endedSession(3,  1.92, "Mumbai, Maharashtra, India", "103.2.15.12"),
        _endedSession(8,  4.17, "Delhi, India",               "49.36.89.201"),
        _endedSession(14, 2.5,  "Mumbai, Maharashtra, India", "103.2.14.56"),
      ],
    },
    {
      id: _genId(), analystId: "12", analystName: "Raj Kumar",
      deviceName: "Safari on iOS (iPad)", browser: "Safari", os: "iOS (iPad)",
      macAddress: _genMac(), location: "Mumbai, Maharashtra, India",
      approvedAt: _daysAgo(8), lastLogin: _daysAgo(1), status: "active",
      sessions: [
        _endedSession(1,  0.75, "Mumbai, Maharashtra, India", "103.2.14.57"),
        _endedSession(8,  1.33, "Mumbai, Maharashtra, India", "103.2.14.57"),
        _endedSession(15, 2.0,  "Pune, Maharashtra, India",  "117.96.14.23"),
      ],
    },
    // Priya Sharma — 1 active device
    {
      id: _genId(), analystId: "34", analystName: "Priya Sharma",
      deviceName: "Chrome on macOS", browser: "Chrome", os: "macOS",
      macAddress: _genMac(), location: "Pune, Maharashtra, India",
      approvedAt: _daysAgo(30), lastLogin: _hoursAgo(5), status: "active",
      sessions: [
        _endedSession(0.2, 2.17, "Pune, Maharashtra, India", "117.96.14.23"),
        _endedSession(2,   3.08, "Pune, Maharashtra, India", "117.96.14.23"),
        _endedSession(5,   4.5,  "Pune, Maharashtra, India", "117.96.15.01"),
        _endedSession(10,  1.67, "Mumbai, Maharashtra, India", "103.2.14.90"),
        _endedSession(18,  5.0,  "Pune, Maharashtra, India", "117.96.14.23"),
      ],
    },
    // Arjun Nair — 1 active + 1 revoked
    {
      id: _genId(), analystId: "56", analystName: "Arjun Nair",
      deviceName: "Firefox on Windows", browser: "Firefox", os: "Windows",
      macAddress: _genMac(), location: "Kochi, Kerala, India",
      approvedAt: _daysAgo(45), lastLogin: _daysAgo(3), status: "active",
      sessions: [
        _endedSession(3,  1.75, "Kochi, Kerala, India",  "182.65.12.45"),
        _endedSession(7,  2.33, "Kochi, Kerala, India",  "182.65.12.45"),
        _endedSession(12, 3.17, "Kochi, Kerala, India",  "182.65.13.01"),
        _endedSession(20, 0.92, "Chennai, Tamil Nadu, India", "49.206.123.01"),
      ],
    },
    {
      id: _genId(), analystId: "56", analystName: "Arjun Nair",
      deviceName: "Chrome on Android", browser: "Chrome", os: "Android",
      macAddress: _genMac(), location: "Kochi, Kerala, India",
      approvedAt: _daysAgo(20), lastLogin: _daysAgo(7), status: "revoked",
      sessions: [
        _endedSession(7,  0.5,  "Kochi, Kerala, India", "182.65.12.46"),
        _endedSession(10, 1.25, "Kochi, Kerala, India", "182.65.12.46"),
        _endedSession(14, 0.75, "Kochi, Kerala, India", "182.65.12.46"),
      ],
    },
    // Deepa Menon — 1 active
    {
      id: _genId(), analystId: "103", analystName: "Deepa Menon",
      deviceName: "Edge on Windows", browser: "Edge", os: "Windows",
      macAddress: _genMac(), location: "Chennai, Tamil Nadu, India",
      approvedAt: _daysAgo(60), lastLogin: _hoursAgo(1), status: "active",
      sessions: [
        _session(_hoursAgo(1), null, "Chennai, Tamil Nadu, India", "49.206.123.45"),
        _endedSession(2,  4.08, "Chennai, Tamil Nadu, India", "49.206.123.45"),
        _endedSession(5,  2.75, "Chennai, Tamil Nadu, India", "49.206.124.01"),
        _endedSession(9,  3.42, "Bengaluru, Karnataka, India", "106.51.14.22"),
        _endedSession(15, 1.5,  "Chennai, Tamil Nadu, India", "49.206.123.45"),
      ],
    },
  );

  _store.requests.push(
    {
      id: _genId(), analystId: "34", analystName: "Priya Sharma",
      deviceName: "Edge on Windows", browser: "Edge", os: "Windows",
      macAddress: _genMac(), location: "Pune, Maharashtra, India",
      requestedAt: _hoursAgo(3), status: "pending",
    },
    {
      id: _genId(), analystId: "78", analystName: "Meena Rao",
      deviceName: "Chrome on macOS", browser: "Chrome", os: "macOS",
      macAddress: _genMac(), location: "Hyderabad, Telangana, India",
      requestedAt: _daysAgo(1), status: "pending",
    },
    {
      id: _genId(), analystId: "91", analystName: "Vikram Desai",
      deviceName: "Safari on iOS (iPhone)", browser: "Safari", os: "iOS (iPhone)",
      macAddress: _genMac(), location: "Delhi, India",
      requestedAt: _daysAgo(2), status: "rejected",
    },
  );
}

export const deviceStore = {
  getAllRequests() { _seed(); return [..._store.requests]; },
  getPendingRequests() { _seed(); return _store.requests.filter((r) => r.status === "pending"); },
  getAllDevices() { _seed(); return [..._store.devices]; },

  getDevicesForAnalyst(analystId) {
    _seed();
    return _store.devices.filter((d) => d.analystId === String(analystId));
  },

  getSessionsForDevice(deviceId) {
    _seed();
    const dev = _store.devices.find((d) => d.id === deviceId);
    return dev ? [...(dev.sessions || [])] : [];
  },

  isApproved(analystId) {
    _seed();
    return _store.devices.some((d) => d.analystId === String(analystId) && d.status === "active");
  },

  hasRequest(analystId) {
    _seed();
    const key = String(analystId);
    return _store.requests.some((r) => r.analystId === key) ||
           _store.devices.some((d) => d.analystId === key);
  },

  addRequest({ analystId, analystName, macAddress }) {
    _seed();
    const key = String(analystId);
    const existingPending = _store.requests.find((r) => r.analystId === key && r.status === "pending");
    if (existingPending) return existingPending;
    const { browser, os, deviceName } = _parseDevice();
    const req = {
      id: _genId(), analystId: key,
      analystName: analystName || `Analyst #${analystId}`,
      deviceName, browser, os,
      macAddress: macAddress || _genMac(),
      location: "Bengaluru, Karnataka, India",
      requestedAt: new Date().toISOString(),
      status: "pending",
    };
    _store.requests.push(req);
    return req;
  },

  approveRequest(id) {
    _seed();
    const req = _store.requests.find((r) => r.id === id);
    if (!req) return;
    req.status = "approved";
    req.approvedAt = new Date().toISOString();
    _store.devices.push({
      id: _genId(), analystId: req.analystId, analystName: req.analystName,
      deviceName: req.deviceName, browser: req.browser, os: req.os,
      macAddress: req.macAddress, location: req.location,
      approvedAt: req.approvedAt, lastLogin: null, status: "active",
      sessions: [],
    });
  },

  rejectRequest(id) {
    _seed();
    const req = _store.requests.find((r) => r.id === id);
    if (req) req.status = "rejected";
  },

  revokeDevice(deviceId) {
    _seed();
    const dev = _store.devices.find((d) => d.id === deviceId);
    if (dev) dev.status = "revoked";
  },

  pendingCount() {
    _seed();
    return _store.requests.filter((r) => r.status === "pending").length;
  },

  genMac: _genMac,
  fmtDate: _fmtDate,
};
